import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useGetQuery } from 'hooks'
import { Card, Icon, PaginateTable, Row } from 'components'

const formatDate = (iso) => {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString([], { month: 'short', day: 'numeric' })
}

export const EventsList = () => {
  const navigate = useNavigate()
  const [page, setPage] = useState({ page: 1, limit: 15 })

  const { data, setPath } = useGetQuery({
    url: `/events?limit=${page.limit}&offset=${(page.page - 1) * page.limit}`
  })

  const updatePage = (newPage) => {
    setPage(newPage)
    setPath(`/events?limit=${newPage.limit}&offset=${(newPage.page - 1) * newPage.limit}`)
  }

  return (
    <Card>
      <Row>
        <PaginateTable
          data={data?.events?.rows || []}
          count={data?.events?.count || 0}
          columns={[
            { title: 'Name', key: 'name' },
            {
              title: 'Start',
              key: 'start_time',
              render: (start_time) => formatDate(start_time)
            },
            {
              title: 'Actions',
              key: 'id',
              className: 'right',
              render: (id) => (
                <>
                  <Link to={`/events/${id}`}><Icon icon="eye" /></Link>{' '}
                  <Link to={`/events/${id}/edit`}><Icon icon="pencil" /></Link>
                </>
              )
            }
          ]}
          addItem={() => navigate('/events/new')}
          onPageChange={updatePage}
        />
      </Row>
    </Card>
  )
}
